/**
 * Play Space Brain Customer Portal — "standard" theme colors
 * A neutral, close-to-original palette (white background, the original
 * teal/orange/navy scheme) for portals embedded in a host site that
 * shouldn't take on the premium brand palette. Selected via colors.js
 * based on the PSB_THEME embed marker — see getThemeVariant().
 * Shape must stay identical to colors.premium.js (same keys/sub-keys).
 */

const colors = {
  background: {
    default: "#ffffff",
  },

  text: {
    main: "#7b809a",
    focus: "#7b809a",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#5b96a9",
    focus: "#5b96a9",
  },

  secondary: {
    main: "#7b809a",
    focus: "#8f93a9",
  },

  info: {
    main: "#f78959",
    focus: "#f78959",
  },

  successBk: {
    main: "#a0bf8a",
    focus: "#a0bf8a",
  },

  success: {
    main: "#6d8a06",
    focus: "#6d8a06",
  },

  warning: {
    main: "#f54e07",
    focus: "#f54e07",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      state: "#5b96a9",
      main: "#cde8e6",
    },

    secondary: {
      main: "#7b809a",
      state: "#8f93a9",
    },

    info: {
      main: "#f78959",
      state: "#f78959",
    },

    success: {
      main: "#6d8a06",
      state: "#6d8a06",
    },

    warning: {
      main: "#f54e07",
      state: "#f54e07",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#5b96a9",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: { main: "#3b5998", dark: "#344e86" },
    twitter: { main: "#55acee", dark: "#3ea1ec" },
    instagram: { main: "#125688", dark: "#0e456d" },
    linkedin: { main: "#0077b5", dark: "#00669c" },
    pinterest: { main: "#cc2127", dark: "#b21d22" },
    youtube: { main: "#e52d27", dark: "#d41f1a" },
    vimeo: { main: "#1ab7ea", dark: "#13a3d2" },
    slack: { main: "#3aaf85", dark: "#329874" },
    dribbble: { main: "#ea4c89", dark: "#e73177" },
    github: { main: "#24292e", dark: "#171a1d" },
    reddit: { main: "#ff4500", dark: "#e03d00" },
    tumblr: { main: "#35465c", dark: "#2a3749" },
  },

  badgeColors: {
    primary: { background: "#f8b3ca", text: "#cc084b" },
    secondary: { background: "#d7d9e1", text: "#6c757d" },
    info: { background: "#f78959", text: "#095bc6" },
    success: { background: "#6d8a06", text: "#339537" },
    warning: { background: "#f54e07", text: "#c87000" },
    error: { background: "#fcd3d0", text: "#f61200" },
    light: { background: "#ffffff", text: "#c7d3de" },
    dark: { background: "#8097bf", text: "#1e2e4a" },
  },

  coloredShadows: {
    primary: "#5b96a9",
    secondary: "#110e0e",
    info: "#f78959",
    success: "#6d8a06",
    warning: "#f54e07",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
